module.exports = __webpack_public_path__ + "assets/images/home/loading-background.d0e53a2c72a21fd357ae4c1039324562.webp";